import HtmlEditor from 'components/HtmlEditor/HtmlEditor';
import LayoutWithMenu from 'components/Layout/LayoutWithMenu';
import { useAuthContext } from 'contexts/AuthContext';
import PropTypes from 'prop-types';
import { Navigate, Route, Routes, useLocation } from 'react-router-dom';
import AppDashboard from 'routes/AppDashboard/AppDashboard';
import CognitoForget from 'routes/Cognito/CognitoForget/CognitoForget';
import CognitoLogin from 'routes/Cognito/CognitoLogin/CognitoLogin';
import Dashboard from 'routes/Dashboard';
import Login from 'routes/Login/Login';
import ScreenRenderer from 'routes/ScreenRenderer/ScreenRenderer';
import { customScreenComponents } from './customScreenComponents';
import NativeLogin, { pendingNativeRedirect } from './routes/NativeLogin/NativeLogin';

export default function PageRoutes() {
  const { state } = useAuthContext();
  return (
    <Routes location={window.location}>
      <Route path="/auth/login" element={<Login />} />
      <Route path="/native-login" element={<NativeLogin />} />
      <Route path="/auth/email/login" element={<CognitoLogin />} />
      <Route path="/auth/email/forgot" element={<CognitoForget />} />
      <Route path="/tsum" element={!state.authenticatedUser ? <RedirectToAuth /> : <Dashboard />} />
      <Route path="/html-editor" element={<HtmlEditor />} />
      <Route
        path="/apps/:appKey"
        element={!state.authenticatedUser ? <RedirectToAuth /> : <AppDashboard />}
      />

      {/* Every Screen, dynamic or custom (customScreenComponents). */}
      <Route
        path="/apps/:appKey/:screenKey/:operation?/:id?"
        element={
          !state.authenticatedUser ? (
            <RedirectToAuth />
          ) : (
            <ScreenRenderer customScreenComponents={customScreenComponents} />
          )
        }
      />

      <Route
        path="/"
        element={
          // tsum's Microsoft login returns here; finish a native app login first.
          pendingNativeRedirect() ? (
            <Navigate to="/native-login" replace />
          ) : state.authenticatedUser ? (
            <Navigate to="/tsum" replace />
          ) : (
            <Navigate to="/auth/login" replace />
          )
        }
      />
      <Route path="*" element={<NotFound />} />
    </Routes>
  );
}

function RedirectToAuth() {
  return <Navigate to="/auth/login" />;
}

function ProtectedRoute({ element, ...props }) {
  const { state } = useAuthContext();

  return (
    <Route {...props} element={!state.authenticatedUser ? <RedirectToAuth /> : element}></Route>
  );
}

function NotFound() {
  const location = useLocation();

  return (
    <LayoutWithMenu>
      <h3>
        No match for <code>{location.pathname}</code>
      </h3>
    </LayoutWithMenu>
  );
}

ProtectedRoute.propTypes = {
  children: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.node), PropTypes.node]).isRequired,
};
